import { render, staticRenderFns } from "./productlist.vue?vue&type=template&id=2ce7e104&scoped=true&"
import script from "./productlist.vue?vue&type=script&lang=js&"
export * from "./productlist.vue?vue&type=script&lang=js&"
import style0 from "./productlist.vue?vue&type=style&index=0&id=2ce7e104&lang=scss&scoped=true&"
import style1 from "./productlist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7e104",
  null
  
)

export default component.exports